import React from "react";
import "./EmailForm.scss";
import { Controller, FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { messages, patterns } from "../../../../utils/constants";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import ReCAPTCHA from "react-google-recaptcha";
import { config } from "../../../../config/config";
import { Images } from "../../../../assets/images";

export interface EmailFormData {
  firstName: string
  lastName: string
  email: string;
  reCaptchaToken: string;
}
interface EmailFormProps {
  onSubmit: (data: EmailFormData) => void;
  loading: boolean;
}

const schema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required(messages.firtName)
    .matches(
      patterns.firstName, messages
    )
    .min(2, messages.minLenFirstName)
    .max(50, messages.maxLenFirstName),

  lastName: yup
    .string()
    .trim()
    .required(messages.lastName)
    .matches(
      patterns.lastName, messages.validLastName
    )
    .min(1, messages.minLenLastName)
    .max(50, messages.maxLenLastName),

  email: yup
    .string()
    .trim()
    .required(messages.email)
    .matches(patterns.email, messages.validEmail),
  reCaptchaToken: yup.string().required("reCAPTCHA verification is required"),
});

const EmailForm: React.FC<EmailFormProps> = ({ onSubmit, loading }) => {
  const methods = useForm<EmailFormData>({
    resolver: yupResolver(schema) as any,
  });

  const {
    handleSubmit,
  } = methods;

  const onSubmitEmail = (data: EmailFormData) => {
    onSubmit(data);
  };

  const handleExpired = () => {
    methods.setValue("reCaptchaToken", "");
    methods.setError("reCaptchaToken", {
      message: "",
    });
  };

  return (
    <div className="EmailForm-container">
      <div className="login-form-header">
        <div className="login-form-title">
          <img src={Images.AppLogo} alt="PROJ.kt" />
        </div>
        <div className="login-form-subtitle">Welcome to PROJ.kt</div>
      </div>
      <FormProvider {...methods}>
        <form
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit(onSubmitEmail)}
          className="signIn-form"
        >

          <div className="signin-form-inputs">
            <CustomInput
              name="firstName"
              placeholder="Enter your first name"
              label="First Name"
              type="text"
              fullWidth
              autoFocus
            />

            <CustomInput
              name="lastName"
              placeholder="Enter your last name"
              label="Last Name"
              type="text"
              fullWidth
            />

            <CustomInput
              name="email"
              placeholder="youremail@domain.com"
              label="Email ID"
              type="text"
              fullWidth
            />

            <div className="recaptcha-container">
              <Controller
                control={methods.control}
                name="reCaptchaToken"
                render={({ field }) => (
                  <ReCAPTCHA
                    {...field}
                    sitekey={config.recaptchaSiteKey!}
                    onChange={(token: string | null) => {
                      field.onChange(token ?? "");
                    }}
                    onExpired={handleExpired}
                  />
                )}
              />
              {
                <span className="recaptcha-error">
                  {methods.formState.errors?.reCaptchaToken?.message}
                </span>
              }
            </div>
          </div>

          <CustomButton
            type="submit"
            text="Continue"
            width="396px"
            height="48px"
            background="#EBA832"
            loading={loading}
            disabled={loading}
          />
        </form>
      </FormProvider>
    </div>
  );
};

export default EmailForm;
